<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>The Latin Lover’s Secret Child</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="9781426877339.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;">CONTENTS</h2>
<div class="contentsEntry" id="contentsEntry2">
<p class="contentsEntryName"><a href="#/9781426877339_fm03#fm03">PROLOGUE</a></p></div>
<div class="contentsEntry" id="contentsEntry3">
<p class="contentsEntryName"><a href="#/9781426877339_ch01#ch01">CHAPTER ONE</a></p></div>
<div class="contentsEntry" id="contentsEntry4">
<p class="contentsEntryName"><span href="#/9781426877339_ch02#ch02" title="Link target outside of Sample">CHAPTER TWO</span></p></div>
<div class="contentsEntry" id="contentsEntry5">
<p class="contentsEntryName"><span href="#/9781426877339_ch03#ch03" title="Link target outside of Sample">CHAPTER THREE</span></p></div>
<div class="contentsEntry" id="contentsEntry6">
<p class="contentsEntryName"><span href="#/9781426877339_ch04#ch04" title="Link target outside of Sample">CHAPTER FOUR</span></p></div>
<div class="contentsEntry" id="contentsEntry7">
<p class="contentsEntryName"><span href="#/9781426877339_ch05#ch05" title="Link target outside of Sample">CHAPTER FIVE</span></p></div>
<div class="contentsEntry" id="contentsEntry8">
<p class="contentsEntryName"><span href="#/9781426877339_ch06#ch06" title="Link target outside of Sample">CHAPTER SIX</span></p></div>
<div class="contentsEntry" id="contentsEntry9">
<p class="contentsEntryName"><span href="#/9781426877339_ch07#ch07" title="Link target outside of Sample">CHAPTER SEVEN</span></p></div>
<div class="contentsEntry" id="contentsEntry10">
<p class="contentsEntryName"><span href="#/9781426877339_ch08#ch08" title="Link target outside of Sample">CHAPTER EIGHT</span></p></div>
<div class="contentsEntry" id="contentsEntry11">
<p class="contentsEntryName"><span href="#/9781426877339_ch09#ch09" title="Link target outside of Sample">CHAPTER NINE</span></p></div>
<div class="contentsEntry" id="contentsEntry12">
<p class="contentsEntryName"><span href="#/9781426877339_ch10#ch10" title="Link target outside of Sample">CHAPTER TEN</span></p></div>
<div class="contentsEntry" id="contentsEntry13">
<p class="contentsEntryName"><span href="#/9781426877339_ch11#ch11" title="Link target outside of Sample">CHAPTER ELEVEN</span></p></div>
<div class="contentsEntry" id="contentsEntry14">
<p class="contentsEntryName"><span href="#/9781426877339_ch12#ch12" title="Link target outside of Sample">CHAPTER TWELVE</span></p></div>
<div class="contentsEntry" id="contentsEntry15">
<p class="contentsEntryName"><span href="#/9781426877339_ch13#ch13" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781426877339_con01.vue?a7dbc41e